import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  AdjacentHubListStateType,
  SetQueryPayloadActionType,
} from 'features/Location/@types/adjacentHub'

export const SLICE_NAME = 'adjacentHubList'

export const initialState: AdjacentHubListStateType = {
  isLoading: false,
  deleteTarget: null,
  isDeleting: false,
  list: [],
  adjacentLocationNames: {},
  query: {
    status: 'ALL',
    search_by: 'location_name',
    search_value: '',
    page_index: 0,
    page_size: 20,
  },
}

const adjacentHubList = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setDeleteTarget: (state, action: PayloadAction<AdjacentHubListStateType['deleteTarget']>) => {
      state.deleteTarget = action.payload
    },
    setIsDeleting: (state, action: PayloadAction<boolean>) => {
      state.isDeleting = action.payload
    },
    setList: (state, action: PayloadAction<AdjacentHubListStateType['list']>) => {
      state.list = action.payload
    },
    setAdjacentLocationNames: (state, action: PayloadAction<Record<string, string>>) => {
      state.adjacentLocationNames = { ...state.adjacentLocationNames, ...action.payload }
    },
    setQuery: (state, action: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...action.payload }
    },
  },
})

export const {
  setIsLoading,
  reset,
  setList,
  setQuery,
  setAdjacentLocationNames,
  setDeleteTarget,
  setIsDeleting,
} = adjacentHubList.actions
export default adjacentHubList.reducer
